import {IPreviewTextVariant} from "../interfaces/preview-text-variant.interface";

export const performancePreviewTexts: IPreviewTextVariant = {
    sidebar_athletes: 'Athletes',
    sidebar_athletes_link: 'athletes',
    athletes_title: 'Athletes',
    create_athlete_button_label: "Create athlete",
    reached_athletes_limit: 'You have reached the limit of athletes.',
    save_athlete_link: '/save-athlete',
    remove_selected_athletes: "Remove selected athletes",
    no_athletes: "No athletes",
    no_athletes_description: "There are no athletes that match the\n" +
        "              selected filters. Select other filters or press the button on the\n" +
        "              right to create a new one.",
    athletes_page_link: '/athletes',
    most_active_athletes: 'Most active athletes',
    sidebar_workouts: 'Workouts',
    sidebar_workouts_link: '/workouts',
    create_workout_link: '/workouts/create',
    workouts_title: "Workouts",
    workout_title: "Workout",
    deleted_workouts: "Deleted workouts",
    push_workouts_to_locaitons: "Push workouts to locations",
    this_workout_is_empty: "This workout is empty.",
    restore_deleted_workouts: "Restore deleted workouts",
    go_to_workouts: "Go to workouts",
    no_deleted_workouts: "There are no deleted workouts.",
    create_workout_title: "Create workout",
    add_new_playlist_to_workout: "Add a new playlist in this workout",
    edit_workout_title: "Edit workout",
    push_workouts_success: "The workouts have been succesfully pushed to the locations!",
    push_workouts_error: "There was an error pushing the workouts to the location.",
    workout_created_success: "Workout created succesfully!",
    workout_edited_success: "Workout edited succesfully!",
    get_workout_error: "There was an error fetching the workout.",
    delete_workout_confirm_text:  "Are you sure you want to delete this workout?",
    athlete_updated_success: "Athlete updated succesfully!",
    athlete_created_success: "Athlete created succesfully!",
    atheletes_bulk_import_error: "There was an error on athletes bulk import.",
    most_active_exercise_athelete_name: "Athlete name",
    athlete_bulk_import_template: "ATHLETES_BULK_IMPORT_TEMPLATE",
    remaining_athletes: "remaining_athletes",
    restore_workout_confirm_text: "Are you sure you want to restore this workout?"
}
